import { TemplateVariableKeys, VariableCategory } from '../types';

interface TemplateVariable {
  key: TemplateVariableKeys;
  type:
    | 'text'
    | 'date'
    | 'number'
    | 'boolean'
    | 'datetime'
    | 'image'
    | 'array'
    | 'object';
}

// Define variables by category
export const variablesByCategory: Record<VariableCategory, TemplateVariable[]> =
  {
    firm: [
      { key: 'firmName', type: 'text' },
      { key: 'firmFullName', type: 'text' },
      { key: 'firmParalegalSig', type: 'image' },
      { key: 'firmManagingParalegalName', type: 'text' },
      { key: 'firmAddress1', type: 'text' },
      { key: 'firmAddress2', type: 'text' },
    ],
    matter: [
      { key: 'matterName', type: 'text' },
      { key: 'matterStatus', type: 'text' },
      { key: 'matterMatterType', type: 'text' },
      { key: 'matterDateOfLoss', type: 'date' },
      { key: 'matterCity', type: 'text' },
      { key: 'matterState', type: 'text' },
      { key: 'matterLocation', type: 'text' },
      { key: 'matterStatuteOfLimitationsDate', type: 'date' },
      { key: 'matterAllClientNames', type: 'text' },
      { key: 'matterMedicalList', type: 'array' },
    ],
    attorney: [{ key: 'attorneySig', type: 'image' }],
    client: [
      { key: 'clientName', type: 'text' },
      { key: 'clientFirstName', type: 'text' },
      { key: 'clientLastName', type: 'text' },
      { key: 'clientEmail', type: 'text' },
      { key: 'clientDateOfBirth', type: 'text' },
      { key: 'clientAddress', type: 'text' },
      { key: 'clientAddress1', type: 'text' },
      { key: 'clientAddress2', type: 'text' },
      { key: 'clientAddress3', type: 'text' },
      { key: 'clientCity', type: 'text' },
      { key: 'clientState', type: 'text' },
      { key: 'clientZip', type: 'text' },
      { key: 'clientPhone', type: 'text' },
      { key: 'clientLastFourOfSsn', type: 'text' },
      { key: 'clientSsn', type: 'text' },
      { key: 'clientHipaaSignedDate', type: 'date' },
      { key: 'clientHipaaSigUrl', type: 'image' },
      { key: 'clientHipaaCleanedSigUrl', type: 'image' },
      { key: 'clientInjuries', type: 'array' },
    ],
    police: [
      { key: 'policeName', type: 'text' },
      { key: 'policeAddress', type: 'text' },
      { key: 'policePhone', type: 'text' },
      { key: 'policeEmail', type: 'text' },
      { key: 'policePoliceReportNumber', type: 'text' },
      { key: 'policeReportedIncidentDate', type: 'date' },
      { key: 'policeDescription', type: 'text' },
      { key: 'policeReportedLocation', type: 'text' },
      { key: 'policeAttestationStatus', type: 'text' },
    ],
    medical: [
      { key: 'medicalName', type: 'text' },
      { key: 'medicalDatesOfService', type: 'text' },
      { key: 'medicalTreatment', type: 'text' },
      { key: 'medicalAddress', type: 'text' },
      { key: 'medicalAddress1', type: 'text' },
      { key: 'medicalAddress2', type: 'text' },
      { key: 'medicalPhone', type: 'text' },
      { key: 'medicalEmail', type: 'text' },
      { key: 'medicalStillTreating', type: 'boolean' },
      { key: 'medicalDateOfRecordsRequest', type: 'date' },
    ],
    insurance: [
      { key: 'insuranceDateFiled', type: 'date' },
      { key: 'insurancePolicyType', type: 'text' },
      { key: 'insuranceHolder', type: 'text' },
      { key: 'insuranceCarrier', type: 'text' },
      { key: 'insurancePolicyNumber', type: 'text' },
      { key: 'insurancePolicyLimitations', type: 'text' },
      { key: 'insuranceVehicleDescription', type: 'text' },
      { key: 'insuranceClaimNumber', type: 'text' },
      { key: 'insuranceAdjusterName', type: 'text' },
      { key: 'insuranceAdjusterPhone', type: 'text' },
      { key: 'insuranceAdjusterEmail', type: 'text' },
      { key: 'insuranceMemberId', type: 'text' },
      { key: 'insuranceGroupId', type: 'text' },
      { key: 'insuranceCarrierPhone', type: 'text' },
      { key: 'insuranceHealthCarrierType', type: 'text' },
      { key: 'insuranceHealthCarrierProgramName', type: 'text' },
    ],
    insurance1p: [
      { key: 'insurance1pCarrier', type: 'text' },
      { key: 'insurance1pPolicyNumber', type: 'text' },
      { key: 'insurance1pClaimNumber', type: 'text' },
      { key: 'insurance1pAdjusterName', type: 'text' },
      { key: 'insurance1pAdjusterPhone', type: 'text' },
      { key: 'insurance1pAdjusterEmail', type: 'text' },
      { key: 'insurance1pPolicyLimitations', type: 'text' },
    ],
    insurance3p: [
      { key: 'insurance3pCarrier', type: 'text' },
      { key: 'insurance3pPolicyNumber', type: 'text' },
      { key: 'insurance3pClaimNumber', type: 'text' },
      { key: 'insurance3pAdjusterName', type: 'text' },
      { key: 'insurance3pAdjusterPhone', type: 'text' },
      { key: 'insurance3pAdjusterEmail', type: 'text' },
      { key: 'insurance3pPolicyLimitations', type: 'text' },
    ],
    insuranceHealth: [
      { key: 'insuranceHealthCarrier', type: 'text' },
      { key: 'insuranceHealthPolicyNumber', type: 'text' },
      { key: 'insuranceHealthMemberId', type: 'text' },
      { key: 'insuranceHealthGroupId', type: 'text' },
      { key: 'insuranceHealthAdjusterName', type: 'text' },
      { key: 'insuranceHealthAdjusterPhone', type: 'text' },
      { key: 'insuranceHealthAdjusterEmail', type: 'text' },
    ],
    incident: [
      { key: 'incidentDescription', type: 'text' },
      { key: 'incidentDateOfLoss', type: 'date' },
      { key: 'incidentTimeOfLoss', type: 'text' },
      { key: 'incidentLocation', type: 'text' },
      { key: 'incidentInjuriesDescribed', type: 'text' },
      { key: 'incidentHospital', type: 'text' },
      { key: 'incidentAmbulance', type: 'text' },
      { key: 'incidentIncidentType', type: 'text' },
    ],
    treatmentRequest: [
      { key: 'treatmentRequestDate', type: 'date' },
      { key: 'treatmentRequestServiceStartDate', type: 'date' },
      { key: 'treatmentRequestServiceEndDate', type: 'text' },
    ],
    treatmentChannel: [
      { key: 'treatmentChannelType', type: 'text' },
      { key: 'treatmentChannelValue', type: 'text' },
      { key: 'treatmentChannelAddress', type: 'text' },
    ],
    transmission: [
      { key: 'transmissionDate', type: 'date' },
      { key: 'transmissionMethod', type: 'text' },
    ],
    recipient: [
      { key: 'recipientName', type: 'text' },
      { key: 'recipientAddress1', type: 'text' },
      { key: 'recipientAddress2', type: 'text' },
      { key: 'recipientCity', type: 'text' },
      { key: 'recipientState', type: 'text' },
      { key: 'recipientZip', type: 'text' },
      { key: 'recipientFullAddress', type: 'text' },
    ],
    foia: [{ key: 'foia', type: 'object' }],
  };

// Flatten all variables into a single array
export const templateVariables: TemplateVariableKeys[] = Object.values(
  variablesByCategory,
)
  .flat()
  .map((v) => v.key);

// Export the categorized variables too for components that need them
export const categorizedTemplateVariables = variablesByCategory;
